import { createBrowserRouter } from "react-router-dom";
import { routes } from "./routes";
import RouteGuard from "../guards/route.guard";
import Styleguide from "../../pages/styleguide/Styleguide";
import Login, { LoginForm } from "../../pages/login/Login";
import PasswordSetup from "../../pages/password-setup/PasswordSetup";
import Home from "../../pages/home/Home";
import Translations from "../../pages/translations/Translations";
import Account from "../../pages/account/Account";
import Faqs from "../../pages/faqs/Faqs";
import PasswordRecovery from "../../pages/password-recovery/PasswordRecovery";
import Contacts from "../../pages/contacts/Contacts";
import Module from "../../pages/module/Module";
import Favorites from "../../pages/favorites/Favorites";
import Unit from "../../pages/unit/Unit";
import Typeforms from "../../pages/typeforms/Typeforms";
import DSS from "../../pages/dss/DSS";
import Explore from "../../pages/explore/Explore";
import GlobalLayout from "../../components/GlobalLayout/GlobalLayout";
import DssForm from "../../pages/dss-form/DssForm";
import Generic from "../../pages/generic/Generic";

const router = createBrowserRouter([
    {
        path: routes.LOGIN.path,
        element: <GlobalLayout />,
        children: [
            {
                path: routes.LOGIN.path,
                element: <Login />,
                children: [
                    {
                        path: routes.LOGIN.path,
                        element: <LoginForm />
                    },
                    {
                        path: routes.FORGOT_PASSWORD.path,
                        element: <PasswordRecovery />
                    },
                    {
                        path: routes.PASSWORD_RECOVERY.path,
                        element: <PasswordSetup />
                    }
                ]
            }
        ]
    },
    {
        path: routes.PASSWORD_RESET.path,
        element: <Login />,
        children: [
            {
                path: routes.PASSWORD_RESET.path,
                element: <PasswordSetup />
            }
        ]
    },
    {
        path: routes.HOME.path,
        element: (
            <RouteGuard>
                <GlobalLayout />
            </RouteGuard>
        ),
        children: [
            {
                path: routes.HOME.path,
                element: <Home />
            },
            {
                path: routes.MODULE.path,
                element: <Module />,
                children: [
                    {
                        path: routes.UNIT.path,
                        element: <Unit />
                    }
                ]
            },
            {
                path: routes.EXPLORE.path,
                element: <Explore />
            },
            {
                path: routes.FAVORITES.path,
                element: <Favorites />
            },
            {
                path: routes.STYLEGUIDE.path,
                element: <Styleguide />
            },
            {
                path: routes.MY_ACCOUNT.path,
                element: <Account />
            },
            {
                path: routes.FAQS.path,
                element: <Faqs />
            },
            {
                path: routes.CONTACTS.path,
                element: <Contacts />
            },
            {
                path: routes.TRANSLATIONS.path,
                element: <Translations />
            },
            {
                path: routes.TYPEFORMS.path,
                element: <Typeforms />
            },
            {
                path: routes.LEGAL.path,
                element: <Generic type="legal" />
            },
            {
                path: routes.DSS.path,
                element: <DSS />,
                children: [
                    {
                        path: routes.DSS_FORM.path,
                        element: <DssForm />
                    }
                ]
            }
        ]
    },
    {
        path: routes.PAGE_404.path,
        element: <p>404</p>
    },
    {
        path: "*",
        element: <p>404</p>
    }
]);

export default router;
